import { Box, Switch, Text, useToast } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import {
  useGetScopeTwoConversionFactors
} from "../../../../hooks/query/conversion-factors";
import { mapScopeTwoFactorsData } from "../helpers";
import { showErrorToast } from "../../../../utils";
import { DataTable } from "../../../../components/DataTable";
import { toggleConversionFactorEnabled } from "../../../../api/conversion-factors/conversion-factors";

function ScopeTwoFactorsTab({ selectedYear, setSelectedYear, organizationStructure }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "conversionFactors.headers"
  });
  const { t: globalTranslation } = useTranslation("translation");
  const toast = useToast();

  const [scopeTwoFactorsData, setScopeTwoFactorsData] = useState([]);

  const {
    isFetching
  } = useGetScopeTwoConversionFactors({
    year: selectedYear
  }, {
    onSuccess: (data) => {
      if (data && data.length > 0) {
        setScopeTwoFactorsData(mapScopeTwoFactorsData(data));
      } else {
        setScopeTwoFactorsData([]);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  const orgElectricityTypes = useMemo(() => {
    return organizationStructure?.electricityTypes || [];
  }, [organizationStructure]);

  const isElectricityTypeEnabled = (row) => {
    return orgElectricityTypes.includes(row._electricityTypeRaw);
  };

  const columns = useMemo(() => {
    return [
      {
        header: t("enabled"),
        accessorKey: "_enabled",
        size: 80,
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <Switch
            size="sm"
            colorScheme="green"
            isChecked={isElectricityTypeEnabled(row.original)}
            onChange={(e) => toggleConversionFactorEnabled({
              scope: "scope2",
              typeId: row.original._electricityTypeRaw,
              typeName: row.original._electricityTypeRaw,
              enabled: e.target.checked,
            })}
          />
        ),
      },
      {
        header: t("country"),
        accessorKey: "country",
        size: 200
      },
      {
        header: t("electricityType"),
        accessorKey: "electricityType",
        size: 150
      },
      {
        header: t("conversionFactor"),
        accessorKey: "conversionFactor",
        size: 200,
        enableColumnFilter: false
      },
      {
        header: t("source"),
        accessorKey: "source",
        size: 150
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, orgElectricityTypes]);

  return (
    <Box>
      {!scopeTwoFactorsData || scopeTwoFactorsData.length === 0 ?
        <Text fontSize="lg" fontWeight="bold">
          {globalTranslation("noDataAvailable")}
        </Text> :
        <DataTable
          data={scopeTwoFactorsData}
          columns={columns}
          isLoading={isFetching}
          enableFilters={true}
        />
      }
    </Box>
  );
}

export default ScopeTwoFactorsTab;